import React, {Component} from "react";
import {
  Row,
  Col,
  ControlLabel,
  Button,
  InputGroup,
  FormControl,
  Modal,
  ProgressBar
}                         from "react-bootstrap";
import Select             from 'react-select';
import                         'react-select/dist/react-select.css';
import axios              from 'axios';
import FileSaver          from 'file-saver';
import moment             from "moment";
import {
  ToastContainer,
  toast
}                         from "react-toastify";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";
import socketIOClient     from "socket.io-client";

import { IS_VALID }       from "utils";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class RawReport extends Component {
  constructor (props) {
    super(props);

    this.state = {
      eventName: null,
      value: null,
      startDate: "",
      endDate: "",
      // isGeneratingReport: false,
      showModal: false,
      isExportStarting: false,
      isExporting: false,
      isExportSuccess: false,
      isExportError: false,
      exportPercentage: 0,
      fileConfig: {
        filename: "",
        blob: ""
      },
      errorMessage: ""
    };

    this.generateReport = this.generateReport.bind(this);
    this.accessible = this.accessible.bind(this);

    this.downloadFile = this.downloadFile.bind(this);
  }

  loadOptions(input, cb, type) {
    var query,
        objItem;

    if (type.toUpperCase() === 'EVENT') {
      query = new Parse.Query('CustomEvent');
      query.select(['eventName', 'type']);
      query.matches('eventName', input, 'i');

      objItem = (obj) => {
        return {
          value: obj.get('eventName'),
          label: obj.get('eventName')
        };
      };
    } else if (type.toUpperCase() === 'VALUE') {
      query = new Parse.Query('CustomEvent');
      query.select(['value']);
      query.matches('value', input, 'i');

      objItem = (obj) => {
        return {
          value: obj.get('value'),
          label: obj.get('value')
        };
      };
    } else if (type.toUpperCase() === 'SEGMENT') {
      query = new Parse.Query('Segments');
      query.select(['name']);
      query.matches('name', input, 'i');

      objItem = (obj) => {
        return {
          value: obj.id,
          label: obj.get('name')
        };
      };
    }

    query.limit(20);
    query.find()
    .then((data) => {
      var options = [];

      var index = (value) => options.map((item) => item.value || item.label).indexOf(value);

      if (type.toUpperCase() === 'EVENT') {
        for (let obj of data) {
          if (obj.get('eventName')) {
            if (index(obj.get('eventName')) === -1) {
              options.push({
                value: obj.get('eventName'),
                label: obj.get('eventName')
              });
            }
          }
        }
      } else if (type.toUpperCase() === 'VALUE') {
        for (let obj of data) {
          if (obj.get('value')) {
            if (index(obj.get('value')) === -1) {
              options.push({
                value: obj.get('value'),
                label: obj.get('value')
              });
            }
          }
        }
      } else {
        if (data.length !== 0) {
          options = data.map(objItem);
        }
      }

      cb(null, {options: options});
    })
    .catch((err) => {
      console.log('loadOptions error: ', err);
      cb(null, {options: []});
    });
  }

  generateReport() {
    let {
      eventName,
      value,
      startDate,
      endDate
    } = this.state;

    if (!IS_VALID(startDate)) {
      toast.error("Start Date is required.");
    } else if (!moment(startDate).isValid()) {
      toast.error("Please select a valid Start Date.");
    } else if (!IS_VALID(endDate)) {
      toast.error("End Date is required.");
    } else if (!moment(endDate).isValid()) {
      toast.error("Please select a valid End Date ");
    } else {
      this.setState({
        showModal: true,
        isExportStarting: true
      });

      axios.post(
        WEB_PATH + '/CustomEvent/reports',
        {
          eventName: eventName !== null ? eventName.value : '',
          value: value !== null ? value.value : '',
          startDate: moment(startDate).startOf("day").format(),
          endDate: moment(endDate).endOf("day").format()
        },
        {
          timeout: 30000
        }
      )
      .then((res) => {
        let {
          fileName,
          socketNspId
        } = res.data;
        
        this.setState({
          isExportStarting: false,
          isExporting: true
        });

        let io = socketIOClient(
          WEB_PATH,
          {
            transports: ["websocket"],
            path: "/socket.io",
            query: {
              nspId: socketNspId
            },
            secure: true
          }
        );

        io.on(
          "export-screen-logs-socket",
          (data) => {

            let {
              status,
              progress,
              fileName,
              message
            } = data;


            if (status === "PROGRESS") {
              this.setState({
                exportPercentage: progress
              });
            } else if (status === "DONE") {
              this.setState({
                exportPercentage: 100
              });

              io.off("export-screen-logs-socket");
              io.close();
              
              axios.get(
                WEB_PATH + '/CustomEvent/download/' + fileName,
                {
                  responseType: "arraybuffer"
                }
              )
              .then((res2) => {
                let blob = new Blob([res2.data], { type: "application/vnd.ms-excel" }),
                    filename = `SCREEN LOGS ${moment().format("MMM DD YYYY hh:mm A")}.xlsx`;

                this.setState({
                  isExporting: false,
                  isExportSuccess: true,
                  exportPercentage: 100,
                  fileConfig: {
                    filename: filename,
                    blob: blob
                  }
                });

                FileSaver.saveAs(blob, filename);
              })
              .catch((err) => {
                let errorMessage = err.message;

                if (
                  err.response &&
                  err.response.data &&
                  ("TextDecoder" in window)
                ) {
                  let enc = new TextDecoder("utf-8");
                  let arr = new Uint8Array(err.response.data);
                  
                  let data = JSON.parse(enc.decode(arr)) || {};

                  if (
                    data.error &&
                    data.error.message
                  ) {
                    errorMessage = data.error.message;
                  }
                }
                
                this.setState({
                  isExporting: false,
                  isExportError: true,
                  errorMessage
                });
              });
            } else if (status === "ERROR") {
              io.off("export-screen-logs-socket");
              io.close();
              
              this.setState({
                isExporting: false,
                isExportError: true,
                errorMessage: message
              });
            }
          }
        );
      })
      .catch((err) => {
        let errorMessage = err.message;

        if (
          err.response &&
          err.response.data &&
          typeof err.response.data === "string"
        ) {
          errorMessage = err.response.data;
        }

        this.setState({
          isExportStarting: false,
          isExportError: true,
          errorMessage
        });
      });

      // axios.post(WEB_PATH + '/CustomEvent/reports', {
      //   eventName: eventName !== null ? eventName.value : '',
      //   value: value !== null ? value.value : '',
      //   startDate: moment(startDate).startOf("day").format(),
      //   endDate: moment(endDate).endOf("day").format()
      // }, {responseType: 'arraybuffer'})
      // .then((res) => {
      //   this.setState({ isGeneratingReport: false });

      //   var blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
      //   FileSaver.saveAs(blob, 'Custom Event Report.xlsx');

      // })
      // .catch((err) => {
      //   this.setState({ isGeneratingReport: false });
      //   console.log('generateReport error', err);
      // });
    }
  }

  downloadFile () {
    let {
      fileConfig
    } = this.state;

    let {
      filename,
      blob
    } = fileConfig

    if (IS_VALID(filename) && IS_VALID(blob)) {
      FileSaver.saveAs(blob, filename);
    }
  }

  accessible(actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

  render () {
    let {
      eventName,
      value,
      startDate,
      endDate,
      
      showModal,
      isExportStarting,
      isExporting,
      isExportSuccess,
      isExportError,
      exportPercentage,
      errorMessage
    } = this.state;

    let requiredSpan = <span style={{ color: "red" }}>*</span>;

    return (
      <div
        style={{
          display: "inline-block"
        }}
        >
        <Row>
          <Col md={3}>
            <ControlLabel>Event Name</ControlLabel>
            <Select.Async
              placeholder="Event"
              autoload={false}
              value={eventName}
              loadOptions={(input, cb) => this.loadOptions(input, cb, 'EVENT')}
              onChange={(val) => this.setState({ eventName: val })}
              disabled={isExportStarting}
              />
          </Col>
          <Col md={3}>
            <ControlLabel>Value</ControlLabel>
            <Select.Async
              placeholder="Value"
              autoload={false}
              value={value}
              loadOptions={(input, cb) => this.loadOptions(input, cb, 'VALUE')}
              onChange={(val) => this.setState({ value: val })}
              disabled={isExportStarting}
              />
          </Col>
          <Col md={5}>
            <ControlLabel>Date {requiredSpan}</ControlLabel>
            <InputGroup>
              <DateTime
                dateFormat="MMM DD, YYYY"
                timeFormat={false}
                value={startDate}
                onChange={(datetime) => {
                    this.setState({ startDate: datetime });
                }}
                inputProps={{
                  placeholder: "MMM DD, YYY",
                  style: {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0
                  },
                  disabled: isExportStarting
                }}
                />
              {/*
                <FormControl
                  type="date"
                  value={startDate}
                  onChange={(e) => {
                    this.setState({ startDate: e.target.value })
                  }}
                  />
                */}
              <InputGroup.Addon>to</InputGroup.Addon>
              <DateTime
                dateFormat="MMM DD, YYYY"
                timeFormat={false}
                value={endDate}
                onChange={(datetime) => {
                    this.setState({ endDate: datetime });
                }}
                inputProps={{
                  placeholder: "MMM DD, YYY",
                  style: {
                    position: "initial",
                    borderRadius: "0 4px 4px 0"
                  },
                  disabled: isExportStarting
                }}
                />
              {/*
                <FormControl
                  type="date"
                  value={endDate}
                  onChange={(e) => {
                    this.setState({ endDate: e.target.value })
                  }}
                  />
                */}
            </InputGroup>
          </Col>
        </Row>
        <Row style={{ marginTop: '10px'}}>
          <Col md={2} mdOffset={5}>
            <Button
              bsStyle="primary"
              style={{
                width: '100%',
                display: this.accessible('GENERATE')
              }}
              disabled={isExportStarting}
              onClick={() => (this.accessible('GENERATE') === '') ? this.generateReport() : {}}
              >
              {
                isExportStarting ?
                <span><i className="fa fa-spinner fa-spin fa-lg" style={{ color: 'white' }}></i>&nbsp;</span>
                : ''
              }
              GENERATE
            </Button>
          </Col>
        </Row>
        <ToastContainer />
        <Modal
        show={showModal}
        onHide={() => {
          if (
            !isExportStarting || isExporting
          ) {
            this.setState({
              showModal: false,

              isExportStarting: false,
              isExporting: false,
              isExportSuccess: false,
              isExportError: false,
              exportPercentage: 0,
              fileConfig: {
                filename: "",
                blob: ""
              },
              errorMessage: ""
            });
          }
        }}
        >
        <Modal.Header closeButton>
          Export Screen Logs
        </Modal.Header>
        <Modal.Body>
          {isExportStarting ? (
            <div style={{ textAlign: "center" }}>
              <i className="fa fa-spinner fa-spin fa-4x"></i>
              <h3>Loading</h3>
            </div>
          ) : (
            ""
          )}
          {
            isExporting ? (
              [
                <p>This may take some time depending on the number of records.</p>,
                <ProgressBar
                  active
                  striped
                  bsStyle="success"
                  now={exportPercentage}
                  label={`${exportPercentage}%`}
                />
              ]
            ) : isExportSuccess || isExportError ? (
              isExportSuccess ? (
                <div style={{ textAlign: "center" }}>
                  <Button
                    bsStyle="success"
                    content="DOWNLOAD FILE"
                    onClick={this.downloadFile}
                  >
                    DOWNLOAD FILE
                  </Button>
                </div>
              ) : (
                [
                  <h3 style={{ textAlign: "center", color: "red" }}>Something went wrong.</h3>,
                  <h4>{errorMessage}</h4>,
                  <div style={{ textAlign: "center" }}>
                    <Button
                      bsStyle="primary"
                      onClick={() => {
                        this.setState({
                          showModal: false,

                          isExportStarting: false,
                          isExporting: false,
                          isExportSuccess: false,
                          isExportError: false,
                          exportPercentage: 0,
                          fileConfig: {
                            filename: "",
                            blob: ""
                          },
                          errorMessage: ""
                        });
                      }}
                    >
                      CLOSE
                    </Button>
                  </div>
                ]
              )
            ) : (
              ""
            )
          }
        </Modal.Body>
        </Modal>
      </div>
    );
  }
}

import {connect} from 'react-redux';

function mapStateToProps(state) {
	var {
		accessjson
	} = state;

	const props = {
		accessjson
	};
	return props;
}

export default connect(mapStateToProps)(RawReport);



// WEBPACK FOOTER //
// ./components/Report/RawReport.js